import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function ApiUrlField({ value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateUrl(value, 'apiUrl');
        return () => validationService.cleanValidation('apiUrl');
    }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="url">URL <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="url"
                    value={value}
                    disabled={disabled}
                    onChange={disabled ? null : (event => onChange(event.target.value))} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiUrlField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.apiUrl,
    }
}

export default connect(mapStateToProps)(ApiUrlField);
